var _circle, _path, _ellipse, _path2, _path3, _path4, _ellipse2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4965 56.2394C42.6821 57.4472 35.3887 57.1409 35.3034 55.8541L34.5 43.7493L41.105 43C41.105 43 42.3221 55.0354 42.4965 56.2394Z",
    fill: "#E19566"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.8263,
    cy: 35.2501,
    rx: 8.81251,
    ry: 13.0753,
    transform: "rotate(-6.24 38.8263 35.2501)",
    fill: "#E9A174"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9225 75.1662C24 62.1251 29.3454 52 37.7191 52C48.8392 52 56.0777 61.7706 60.7208 74.2216C54.6774 77.8887 47.5853 80 40 80C33.0919 80 26.5929 78.2488 20.9225 75.1662Z",
    fill: "#FFD98F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4771 79.9715C30.1487 79.6598 22.4715 76.8017 16.2014 72.1532C19.1257 64.213 24.4064 56.2046 30.0695 56.8437C39.1284 57.8689 39.6173 71.3149 38.4771 79.9715Z",
    fill: "#FFDE9C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 28.0409C22.5 24.2331 25.541 22.0056 26.5293 20.9649C28.526 18.855 29.724 13.2295 33.9431 13.2295C35.1411 13.2295 37.002 13.9375 38.1721 13.9375C39.6356 13.9314 42.5488 11 45.486 11C50.4058 11 51.5 15.601 51.5 17.015C51.5 22.1922 45.1545 26.0995 44.3119 26.5661C43.9545 25.9717 42.3152 23.7482 41.7701 23.4115C41.1172 24.795 36.7105 27.0976 33.38 29.1607C31.5151 30.3171 30.341 39.292 30.369 40C27.2581 40.0101 22.5 35.2143 22.5 28.0409Z",
    fill: "#7E5933"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.5,
    cy: 37.5,
    rx: 2,
    ry: 2.5,
    fill: "#E9A174"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.3d43fddc797bd1b0849ef46974998720.svg";
export { ForwardRef as ReactComponent };